import React from 'react';

/**
 * SwadharmaBand — the common visual strand across every Swadharma PRO app.
 * A 3-segment tri-band (navy · gold · saffron) rendered at the top of every page.
 * Pure presentational; no props needed for the standard version.
 */
const SwadharmaBand = ({ thin = false, inverse = false }) => {
    const classes = [
        'swadharma-band',
        thin ? 'swadharma-band-thin' : '',
        inverse ? 'swadharma-band-inverse' : ''
    ].filter(Boolean).join(' ');
    return <div className={classes} aria-hidden="true" role="presentation" />;
};

export default SwadharmaBand;
